/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Message_AriaInputs */

const en_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your message`)
};

const ar_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رسالتك`)
};

const bn_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার বার্তা`)
};

const de_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Nachricht`)
};

const es_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu mensaje`)
};

const fr_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre message`)
};

const pt_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua mensagem`)
};

const zh_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的留言`)
};

const tr_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesajınız`)
};

const ru_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваше сообщение`)
};

const pl_form_message_aria = /** @type {(inputs: Form_Message_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja wiadomość`)
};

/**
* | output |
* | --- |
* | "Your message" |
*
* @param {Form_Message_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_message_aria = /** @type {((inputs?: Form_Message_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Message_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_message_aria(inputs)
	if (locale === "bn") return bn_form_message_aria(inputs)
	if (locale === "de") return de_form_message_aria(inputs)
	if (locale === "es") return es_form_message_aria(inputs)
	if (locale === "fr") return fr_form_message_aria(inputs)
	if (locale === "pt") return pt_form_message_aria(inputs)
	if (locale === "zh") return zh_form_message_aria(inputs)
	if (locale === "tr") return tr_form_message_aria(inputs)
	if (locale === "ru") return ru_form_message_aria(inputs)
	if (locale === "pl") return pl_form_message_aria(inputs)
	return en_form_message_aria(inputs)
});